import Headroom from 'headroom.js';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

const body = document.querySelector('body');
const burger = document.querySelector('.c-hamburger');
const menu = document.querySelector('.m-menu');
const mMenuIsOpen = 'm-menu--is-open';
const header = document.querySelector('header');
const freezeHeader = 'frozen';

const getHeadroomOptions = () => {
  return { offset: 64, tolerance: 10 };
};

const handleToggleMenu = e => {
  burger.setAttribute(
    'aria-expanded',
    burger.getAttribute('aria-expanded') === 'true' ? false : true,
  );

  menu.setAttribute(
    'aria-hidden',
    menu.getAttribute('aria-hidden') === 'true' ? false : true,
  );

  if (body.classList.contains(mMenuIsOpen)) {
    body.classList.remove(mMenuIsOpen);
    header.classList.remove(freezeHeader);
    enableBodyScroll(menu);
  } else {
    body.classList.add(mMenuIsOpen);
    header.classList.add(freezeHeader);
    disableBodyScroll(menu);
    // asd
  }
};

const init = () => {
  if (header) {
    const headroom = new Headroom(header, getHeadroomOptions());
    headroom.init();
  }

  if (burger) burger.addEventListener('click', e => handleToggleMenu(e));
};

const toggleMobileMenu = {
  init,
};

export default toggleMobileMenu;
